import React, { useEffect, useState } from 'react'
import './Header.css'
import logo from '../assets/Ousslogo.png'
import { useStateValue } from '../StateProvider';
import {useTranslation} from "react-i18next";
import france from '../assets/france.png'
import uk from '../assets/united-kingdom.png'
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';

function Header() {
    const [btnClicked, setBtnClicked] = useState(1);
    const [state, dispatch] = useStateValue();
    const [scrollTop, setScrollTop] = useState(0);
    const [menuClicked, setMenuClicked] = useState(false);
  
    const onScroll = (e) => {
      setScrollTop(e.target.documentElement.scrollTop);
    }
    useEffect(() =>{
        dispatch({
            type : "BTN",
            btn : btnClicked
        })
    },[btnClicked]);
  
    useEffect(() => {
      window.addEventListener('scroll', onScroll);
    },[]);
  
    useEffect(() => {
      console.log(state.Ref[1], scrollTop)
      if (state.Ref[1] >= scrollTop  + 30 || !state.Ref[1]){
        setBtnClicked(1);
      }else if (state.Ref[2] >= scrollTop + 30){
        setBtnClicked(2);
      }else  if (state.Ref[3] >= scrollTop + 30){
        setBtnClicked(3);
      }else  if (state.Ref[4] >= scrollTop + 30){
        setBtnClicked(4);
      }else{
        setBtnClicked(5);
      }
    }, [scrollTop])

    const handleNav = (i) =>{
            window.scrollTo({
              top: state.Ref[i],
              left: 0,
              behavior: "smooth"
            });
          };
          const {t, i18n} = useTranslation('common');

    return (
        <div className="header">
           <div className="header__logo"  onClick={() => {handleNav(0)}}>
               <img src={logo} alt="" className="img__logo"/>
           </div>
          <div onClick={() =>setMenuClicked(!menuClicked)}  className={!menuClicked ? 'header__nav__open header__nav__open__show' : 'header__nav__open'}>
            <MenuIcon fontSize="large" className="menuIcon"/>
          </div>
          <div onClick={() =>setMenuClicked(!menuClicked)} className={menuClicked ? ' header__nav__open header__nav__close__show' : 'header__nav__close'}>
            <CloseIcon fontSize="large" className="closeIcon"/>
          </div>
            <div className={menuClicked ? ' header__items header__items__show' : 'header__items'}>
                <p className={btnClicked === 1 ? 'button button__red' : 'button'} onClick={() => {handleNav(0)}}>{t('header.home')}</p>
                <p className={btnClicked === 2 ? 'button button__red' : 'button'} onClick={() => {handleNav(1)}}>{t('header.about')}</p>
                <p className={btnClicked === 3 ? 'button button__red' : 'button'} onClick={() => {handleNav(2)}}>{t('header.services')}</p>
                <p className={btnClicked === 4 ? 'button button__red' : 'button'} onClick={() => {handleNav(3)}}>{t('header.portfolio')}</p>
                <p className={btnClicked === 5 ? 'button button__red' : 'button'} onClick={() => {handleNav(5)}}>{t('header.contact')}</p>
            </div>
            <div className="header__lang">
              <button className={t('en') ? "langbutton" : "langbutton_active"} style={{ backgroundImage: `url(${france})` }} onClick={() => i18n.changeLanguage('fr')}></button>
              <button className={t('en') ? "langbutton_active" : "langbutton"} style={{ backgroundImage: `url(${uk})` }} onClick={() => i18n.changeLanguage('en')}></button>
            </div>
        </div>
    )
}

export default Header
